<template>
  <div div class="animated fadeIn">
    <b-modal ref="modalDisapproved" hide-footer title="REEMBOLSO VIAGEM">
     <Forms ref="frmExpense"
      :title="'DESPESAS INCORRIDAS - MOTIVO'"
      :showHelp="false"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12 pt-2 pb-3">
          <label><small class="text-danger">*</small> Motivo:</label>
          <div class="input-group">
            <b-form-textarea
                v-model="form.motivoIncorrida.value"
                :placeholder="'Descreva aqui o motivo da reprovação do item da despesa'"
                :rows="form.motivoIncorrida.rows"
                :size="form.motivoIncorrida.maxlength"
                :noResize="form.motivoIncorrida.noResize"></b-form-textarea>
    </div>
        </div>
      </div>
     </Forms>
    </b-modal>
  </div>
</template>
<script>
import { loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseItemForm from './modalDisapproved-form.js'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'

const ExpenseItemData = {
  'items': null,
  'motivoIncorrida': null
}

export default {
  name: 'ExpenseTravelModalCredit',
  mixins: [ ActionsForm ],
  data () {
    return {
      objSelected: null,
      itemSelected: null,
      data: ExpenseItemData,
      form: ExpenseItemForm
    }
  },
  methods: {
    onLoad () {
      this.form.motivoIncorrida.value = ''
    },
    showModal (obj, items) {
      this.objSelected = obj
      this.itemSelected = items
      this.$refs['modalDisapproved'].show()
    },
    hideModal () {
      this.$refs['modalDisapproved'].hide()
    },
    onUpdate () {
      loading.push()
      this.data.items = this.itemSelected
      console.log(this.data)
      ExpenseItemRepository.SetDisapproved(this.data)
        .then((response) => {
          this.hideModal()
          this.onResult(response)
          loading.close()
          this.$emit('Reload')
        })
        .catch(this.onException)
    }
  }
}
</script>
<style scoped>
.upload {
  border: solid 1px #ccc;
  border-radius: 4px;
  background-color: #efefef;
  padding: 5%;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelrefund/details/components/modal/disapproved/modalDisapproved.vue